<template>
<div>
    <v-container grid-list-lg>
        <v-layout  wrap  row  justify-center>
            <v-flex xs12 sm12 md6 lg4>
                <v-card ref="form">
                <v-card-title><v-icon>map</v-icon>&nbsp;<h3>NAKVANE GVAVE</h3></v-card-title>
                        <v-divider></v-divider>
                <v-card-text>
                    <v-text-field
                    ref="name"
                    v-model="id_blagajne"
                    label="ID Blagajne"
                    placeholder="..."
                                disabled
                    ></v-text-field>
                    <v-text-field
                    ref="name"
                    v-model="naziv_blagajne"
                    label="Naziv blagajne"
                    placeholder="..."
                                disabled
                    ></v-text-field>
                    <v-text-field
                    ref="name"
                    v-model="zasedenost"
                    label="Zasedenost"
                    placeholder="..."
                                disabled
                    ></v-text-field>
                    <v-text-field
                    ref="name"
                    v-model="cas_osvezitve"
                    label="Čas osvežitve"
                    placeholder=""
                                disabled
                    ></v-text-field>
                    <v-text-field
                    ref="name"
                    v-model="sprememba_zasedenosti"
                    label="Sprememba zasedenosti"
                    placeholder="..."
                    ></v-text-field>
                    <v-text-field
                    ref="name"
                    v-model="cas_spremembe"
                    label="Čas spremembe"
                    placeholder=""
                                disabled
                    ></v-text-field>
                </v-card-text>
                <v-divider class="mt-4"></v-divider>
                <v-card-actions>
                    <v-btn flat>Prekliči spremembe</v-btn>
                    <v-spacer></v-spacer>
                    <v-slide-x-reverse-transition>
                    <v-tooltip
                        v-if="formHasErrors"
                        left
                    >
                        <v-btn
                        slot="activator"
                        icon
                        class="my-0"
                        @click="resetForm"
                        >
                        <v-icon>refresh</v-icon>
                        </v-btn>
                        <span>Refresh form</span>
                    </v-tooltip>
                    </v-slide-x-reverse-transition>
                    <v-btn color="primary" flat @click="submit">Posodobi</v-btn>
                </v-card-actions>
                </v-card>
            </v-flex>
            <br>
            <v-flex xs12 sm12 md6 lg4>
            <v-card ref="form">
            <v-card-title><v-icon>map</v-icon>&nbsp;<h3>BOHINJ - VORANČKOJCA</h3></v-card-title>
                    <v-divider></v-divider>
            <v-card-text>
                <v-text-field
                ref="name"
                v-model="id_blagajne"
                label="ID Blagajne"
                placeholder="..."
                            disabled
                ></v-text-field>
                <v-text-field
                ref="name"
                v-model="naziv_blagajne"
                label="Naziv blagajne"
                placeholder="..."
                            disabled
                ></v-text-field>
                <v-text-field
                ref="name"
                v-model="zasedenost"
                label="Zasedenost"
                placeholder="..."
                            disabled
                ></v-text-field>
                <v-text-field
                ref="name"
                v-model="cas_osvezitve"
                label="Čas osvežitve"
                placeholder=""
                            disabled
                ></v-text-field>
                <v-text-field
                ref="name"
                v-model="sprememba_zasedenosti"
                label="Sprememba zasedenosti"
                placeholder="..."
                ></v-text-field>
                <v-text-field
                ref="name"
                v-model="cas_spremembe"
                label="Čas spremembe"
                placeholder=""
                            disabled
                ></v-text-field>
            </v-card-text>
            <v-divider class="mt-4"></v-divider>
            <v-card-actions>
                <v-btn flat>Prekliči spremembe</v-btn>
                <v-spacer></v-spacer>
                <v-slide-x-reverse-transition>
                <v-tooltip
                    v-if="formHasErrors"
                    left
                >
                    <v-btn
                    slot="activator"
                    icon
                    class="my-0"
                    @click="resetForm"
                    >
                    <v-icon>refresh</v-icon>
                    </v-btn>
                    <span>Refresh form</span>
                </v-tooltip>
                </v-slide-x-reverse-transition>
                <v-btn color="primary" flat @click="submit">Posodobi</v-btn>
            </v-card-actions>
            </v-card>
        </v-flex>
        <br>
        <v-flex xs12 sm12 md6 lg4>
            <v-card ref="form">
            <v-card-title><v-icon>map</v-icon>&nbsp;<h3>BOHINJ - UKANC</h3></v-card-title>
                    <v-divider></v-divider>
            <v-card-text>
                <v-text-field
                ref="name"
                v-model="id_blagajne"
                label="ID Blagajne"
                placeholder="..."
                            disabled
                ></v-text-field>
                <v-text-field
                ref="name"
                v-model="naziv_blagajne"
                label="Naziv blagajne"
                placeholder="..."
                            disabled
                ></v-text-field>
                <v-text-field
                ref="name"
                v-model="zasedenost"
                label="Zasedenost"
                placeholder="..."
                            disabled
                ></v-text-field>
                <v-text-field
                ref="name"
                v-model="cas_osvezitve"
                label="Čas osvežitve"
                placeholder=""
                            disabled
                ></v-text-field>
                <v-text-field
                ref="name"
                v-model="sprememba_zasedenosti"
                label="Sprememba zasedenosti"
                placeholder="..."
                ></v-text-field>
                <v-text-field
                ref="name"
                v-model="cas_spremembe"
                label="Čas spremembe"
                placeholder=""
                            disabled
                ></v-text-field>
            </v-card-text>
            <v-divider class="mt-4"></v-divider>
            <v-card-actions>
                <v-btn flat>Prekliči spremembe</v-btn>
                <v-spacer></v-spacer>
                <v-slide-x-reverse-transition>
                <v-tooltip
                    v-if="formHasErrors"
                    left
                >
                    <v-btn
                    slot="activator"
                    icon
                    class="my-0"
                    @click="resetForm"
                    >
                    <v-icon>refresh</v-icon>
                    </v-btn>
                    <span>Refresh form</span>
                </v-tooltip>
                </v-slide-x-reverse-transition>
                <v-btn color="primary" flat @click="submit">Posodobi</v-btn>
            </v-card-actions>
            </v-card>
        </v-flex>
        <br>
                
        </v-layout>
    </v-container>
</div>
</template>

<script>
export default {
    name: 'blagajna',
    data: () => ({
    countries: ['Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Anguilla', 'Antigua &amp; Barbuda', 'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan', 'Bolivia', 'Bosnia &amp; Herzegovina', 'Botswana', 'Brazil', 'British Virgin Islands', 'Brunei', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cambodia', 'Cameroon', 'Cape Verde', 'Cayman Islands', 'Chad', 'Chile', 'China', 'Colombia', 'Congo', 'Cook Islands', 'Costa Rica', 'Cote D Ivoire', 'Croatia', 'Cruise Ship', 'Cuba', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Estonia', 'Ethiopia', 'Falkland Islands', 'Faroe Islands', 'Fiji', 'Finland', 'France', 'French Polynesia', 'French West Indies', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Gibraltar', 'Greece', 'Greenland', 'Grenada', 'Guam', 'Guatemala', 'Guernsey', 'Guinea', 'Guinea Bissau', 'Guyana', 'Haiti', 'Honduras', 'Hong Kong', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Isle of Man', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jersey', 'Jordan', 'Kazakhstan', 'Kenya', 'Kuwait', 'Kyrgyz Republic', 'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macau', 'Macedonia', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Mauritania', 'Mauritius', 'Mexico', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro', 'Montserrat', 'Morocco', 'Mozambique', 'Namibia', 'Nepal', 'Netherlands', 'Netherlands Antilles', 'New Caledonia', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Norway', 'Oman', 'Pakistan', 'Palestine', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Poland', 'Portugal', 'Puerto Rico', 'Qatar', 'Reunion', 'Romania', 'Russia', 'Rwanda', 'Saint Pierre &amp; Miquelon', 'Samoa', 'San Marino', 'Satellite', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'South Africa', 'South Korea', 'Spain', 'Sri Lanka', 'St Kitts &amp; Nevis', 'St Lucia', 'St Vincent', 'St. Lucia', 'Sudan', 'Suriname', 'Swaziland', 'Sweden', 'Switzerland', 'Syria', 'Taiwan', 'Tajikistan', 'Tanzania', 'Thailand', "Timor L'Este", 'Togo', 'Tonga', 'Trinidad &amp; Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Turks &amp; Caicos', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States', 'Uruguay', 'Uzbekistan', 'Venezuela', 'Vietnam', 'Virgin Islands (US)', 'Yemen', 'Zambia', 'Zimbabwe'],
    errorMessages: '',
    id_blagajne: 123,
    naziv_blagajne: "NAKVANE GVAVE",
    zasedenost: 58,
    sprememba_zasedenosti: 42,
    cas_osvezitve: "08.08.2018 ob 13:40",
    cas_spremembe: "",
    formHasErrors: null
  }),

  computed: {
    form () {
      return {
        name: this.name,
        address: this.address,
        city: this.city,
        state: this.state,
        zip: this.zip,
        country: this.country
      }
    }
  },

  watch: {
    name () {
      this.errorMessages = ''
    }
  },

  methods: {
    addressCheck () {
      this.errorMessages = this.address && !this.name
        ? 'Hey! I\'m required'
        : ''

      return true
    },
    resetForm () {
      this.errorMessages = []
      this.formHasErrors = false

      Object.keys(this.form).forEach(f => {
        this.$refs[f].reset()
      })
    },
    submit () {
      this.formHasErrors = false

      Object.keys(this.form).forEach(f => {
        if (!this.form[f]) this.formHasErrors = true

        this.$refs[f].validate(true)
      })
    }
  }
}
</script>

<style>

</style>


